<template>
  <v-card class="elevation-0 flex-div">
    <div class="px-3 mt-1 py-1">
      <div class="flex-div">
        <h4 class="mb-1">{{ pos.name }}</h4>
        <span
          v-if="pos.distance || pos.distance === 0"
          class="ml-auto caption grey--text text--darken-3"
          >{{ Math.round(pos.distance * 100) / 100 }} km</span
        >
      </div>
      <p class="font-weight-normal my-0 grey--text text--darken-3">
        {{ pos.location.line_1 }}<br />{{ pos.location.zipcode }}
        {{ pos.location.state }}
      </p>
    </div>
    <div class="ml-auto">
      <v-btn
        @click="openMap()"
        medium
        block
        class="h-100 mx-0 my-0 elevation-0"
        color="grey lighten-4"
        ><img
          width="18px"
          class="mr-2"
          src="../assets/img/map.svg"
          alt="map"
        />map</v-btn
      >
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    origin: {
      require: true
    },
    pos: {
      type: Object,
      require: true
    }
  },
  computed: {
    originIsNull () {
      return !this.origin.latitude && !this.origin.longitude
    }
  },
  methods: {
    openMap () {
      const originParam = this.originIsNull
        ? ''
        : `&origin=${this.origin.latitude},${this.origin.longitude}`
      const destinationParam = `&destination=${this.pos.location.latitude},${this.pos.location.longitude}`

      window.open(
        `https://www.google.com/maps/dir/?api=1${originParam}${destinationParam}`
      )
    }
  }
}
</script>
